export default {
  "mt-4": "_mt-4_171cz7"
};